"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.GridCell = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var theme_get_1 = require("@styled-system/theme-get");
var Box_1 = require("../Box");
var Container = (0, styled_components_1.default)(Box_1.Box)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: grid;\n\n  ", "\n\n  ", "\n"], ["\n  display: grid;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var cellSize = _a.cellSize, cellGap = _a.cellGap, rest = __rest(_a, ["cellSize", "cellGap"]);
    if (Array.isArray(cellSize)) {
        return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        grid-column-gap: ", ";\n        grid-row-gap: ", ";\n\n        ", "\n      "], ["\n        grid-column-gap: ", ";\n        grid-row-gap: ", ";\n\n        ", "\n      "])), (0, theme_get_1.themeGet)("space.".concat(cellGap), cellGap)(rest), (0, theme_get_1.themeGet)("space.".concat(cellGap), cellGap)(rest), cellSize.map(function (cs, i) {
            if (i === 0) {
                return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              grid-template-columns: repeat(\n                auto-fill,\n                minmax(", ", 1fr)\n              );\n            "], ["\n              grid-template-columns: repeat(\n                auto-fill,\n                minmax(", ", 1fr)\n              );\n            "])), (0, theme_get_1.themeGet)("space.".concat(cs), cs)(rest));
            }
            return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            @media (min-width: ", ") {\n              grid-template-columns: repeat(\n                auto-fill,\n                minmax(", ", 1fr)\n              );\n            }\n          "], ["\n            @media (min-width: ", ") {\n              grid-template-columns: repeat(\n                auto-fill,\n                minmax(", ", 1fr)\n              );\n            }\n          "])), function (props) { return props.theme.breakpoints[i - 1]; }, (0, theme_get_1.themeGet)("space.".concat(cs), cs)(rest));
        }));
    }
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      grid-column-gap: ", ";\n      grid-row-gap: ", ";\n      grid-template-columns: repeat(\n        auto-fill,\n        minmax(", ", 1fr)\n      );\n    "], ["\n      grid-column-gap: ", ";\n      grid-row-gap: ", ";\n      grid-template-columns: repeat(\n        auto-fill,\n        minmax(", ", 1fr)\n      );\n    "])), (0, theme_get_1.themeGet)("space.".concat(cellGap), cellGap)(rest), (0, theme_get_1.themeGet)("space.".concat(cellGap), cellGap)(rest), (0, theme_get_1.themeGet)("space.".concat(cellSize), cellSize)(rest));
}, styled_system_1.grid);
exports.GridCell = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"])));
var Grid = function (_a) {
    var children = _a.children, _b = _a.cellSize, cellSize = _b === void 0 ? 10 : _b, _c = _a.cellGap, cellGap = _c === void 0 ? 5 : _c, rest = __rest(_a, ["children", "cellSize", "cellGap"]);
    return (react_1.default.createElement(Container, __assign({ cellSize: cellSize, cellGap: cellGap }, rest), react_1.default.Children.map(children, function (child, i) { return (react_1.default.createElement(exports.GridCell, { key: i }, child)); })));
};
exports.Grid = Grid;
exports.Grid.defaultProps = {
    width: "100%",
    height: "100%",
};
exports.Grid.displayName = "Grid";
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Grid.js.map